import { SessionServerSelectors, SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { CreateExtractTasksMode } from '~src/extractTask/actions/CreateExtractTaskAction';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { isSingleDatasourceWithExtract, isSingleEmbeddedDatasource } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { currentUserIsOwnerOrAdmin } from '~src/spacesPlatform/utils/MixedContentHelpers';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { getAppStore } from '../../../bootstrap/redux/store/AppStore';
import { Messages } from '../../../codegen/Localize';
import { IDataSourceInfo } from '../../../datasource/models/IDataSourceInfo';
import { IRefreshExtractAction } from '../../../spacesPlatform/models/actionNames';
import { IContentInfo } from '../../../spacesPlatform/models/IContentInfo';
import { createExtractRefresh } from '../../actions/extractRefresh/CreateExtractRefreshAction';

export const ScheduleRefreshWithBridgeEntityAction: IEntityAction<IDataSourceInfo, IRefreshExtractAction> = {
  name: EntityActionNames.ScheduleRefreshWithBridge,
  translateName: Messages.bridgeLegacySchedule_action,

  isVisible: (targetItems: IDataSourceInfo[], appState: AppState) => {
    const isLegacySchedulesWithBridgeDisabled = FeatureFlags.disableLegacySchedulesWithBridgeEnabled;
    if(isLegacySchedulesWithBridgeDisabled){
      return !isLegacySchedulesWithBridgeDisabled; // Hide the action if legacy schedules with bridge is disabled
    }
    const isExtractSSSEnabledForServer = SessionServerSelectors.isSelfServiceSchedulesRefreshEnabled(getAppStore().getState())
    && SessionServerSelectors.isOnlineEnvironment(getAppStore().getState());
    const isExtractSSSEnabledForSite = SessionSiteSelectors.isSelfServiceSchedulesForRefreshEnabled(getAppStore().getState());
    const isExtractSSSEnabled = isExtractSSSEnabledForServer && isExtractSSSEnabledForSite;

    return isExtractSSSEnabled
      && isSingleDatasourceWithExtract(targetItems)
      && !isSingleEmbeddedDatasource(targetItems);
  },

  isClickable: (availableActions: IRefreshExtractAction, targetItems: IDataSourceInfo[]) => {
    const appState = getAppStore().getState();
    return currentUserIsOwnerOrAdmin(appState, targetItems[0]);
  },

  createReduxAction: (targetItems: IContentInfo[]) => createExtractRefresh(targetItems, CreateExtractTasksMode.AllowScheduleOnlyOnClient)
};
